(function(){
  var VAR = (window.JRX && window.JRX.variants) || [];
  var scope = document.querySelector('.jrx'); if(!scope) return;

  var skuWrap = scope.querySelector('.jrx__sku'), skuEl = scope.querySelector('[data-jr-sku]');
  function findVariant(id){ for(var i=0;i<VAR.length;i++){ if(String(VAR[i].id)===String(id)) return VAR[i]; } return null; }
  function syncSku(){
    var form = document.querySelector('form[action*="/cart/add"]');
    var idIn = form && form.querySelector('[name="id"]');
    if(!idIn || !skuEl) return;
    var m = findVariant(idIn.value);
    if(m){ if(m.sku){ skuEl.textContent = m.sku; if(skuWrap) skuWrap.style.display=''; } else if(skuWrap){ skuWrap.style.display='none'; } }
  }
  document.addEventListener('change', function(e){ if(e.target.closest && e.target.closest('form[action*="/cart/add"]')) setTimeout(syncSku,60); });
  document.addEventListener('variant:change', function(){ setTimeout(syncSku,10); });
  setTimeout(syncSku,400);

  var strip = scope.querySelector('[data-jr-strip]');
  var info = scope.querySelector('.jr-info');
  var btn = info && info.querySelector('.jr-info__btn');
  var pop = info && info.querySelector('.jr-pop');
  if(strip && info && btn && pop){
    var hoverOk = window.matchMedia('(hover:hover)').matches;
    function place(){
      pop.style.left='0px';
      var r=pop.getBoundingClientRect(), over=r.right-(window.innerWidth-8);
      if(over>0){ pop.style.left=(-over)+'px'; }
      var l=pop.getBoundingClientRect();
      if(l.left<8){ pop.style.left=(parseFloat(pop.style.left||0)+(8-l.left))+'px'; }
    }
    var autoTimer=null;
    function setOpen(o){
      info.dataset.open = o?'true':'false';
      btn.setAttribute('aria-expanded', o?'true':'false');
      if(o){ place(); if(!hoverOk){ clearTimeout(autoTimer); autoTimer=setTimeout(function(){ setOpen(false); },4000); } }
      else { clearTimeout(autoTimer); }
    }
    if(hoverOk){
      strip.addEventListener('mouseenter', function(){ setOpen(true); });
      strip.addEventListener('mouseleave', function(){ setOpen(false); });
    }
    strip.addEventListener('click', function(e){ if(pop.contains(e.target)) return; e.stopPropagation(); setOpen(info.dataset.open!=='true'); });
    document.addEventListener('click', function(e){ if(!strip.contains(e.target)) setOpen(false); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') setOpen(false); });
    window.addEventListener('scroll', function(){ if(info.dataset.open==='true') setOpen(false); }, {passive:true});
  }

  var el = scope.querySelector('[data-jr-timer]');
  if(el){
    var FB = el.innerHTML;
    function tick(){
      var f=new (Intl['DateTime'+'Format'])('en-US',{timeZone:'America/New_York',weekday:'short',hour:'2-digit',minute:'2-digit',second:'2-digit',hour12:false}), o={};
      f.formatToParts(new Date()).forEach(function(p){o[p.type]=p.value;});
      var d={Sun:0,Mon:1,Tue:2,Wed:3,Thu:4,Fri:5,Sat:6}, h=parseInt(o.hour,10); if(h===24)h=0;
      var dow=d[o.weekday], sec=h*3600+parseInt(o.minute,10)*60+parseInt(o.second,10), cut=15*3600;
      if(dow>=1 && dow<=5 && sec<cut){ var l=cut-sec, hh=Math.floor(l/3600), mm=Math.floor((l%3600)/60), ss=l%60;
        el.innerHTML = "Order within <span class='jr-count'>"+(hh>0?hh+':':'')+(hh>0?String(mm).padStart(2,'0'):mm)+':'+String(ss).padStart(2,'0')+"</span> for same-day shipping.";
      } else { el.innerHTML = FB; }
    }
    tick(); setInterval(tick,1000);
  }

  // Reorder product info to match Debut: title, subtitle, reviews, price, Part#, badges.
  function reorderInfo(){
    var title=document.querySelector('.product__title');
    var priceEl=document.querySelector('.product__info-container .price')||document.querySelector('.price');
    var jrx=document.querySelector('.jrx');
    if(!title||!priceEl||!jrx) return true;
    var sub=jrx.querySelector('.jrx__sub')||document.querySelector('.jrx__sub');
    var partno=document.querySelector('.jrx__sku'), badges=document.querySelector('.jrx__badges');
    if(!(partno&&badges)) return true;
    var reviews=document.getElementById('product_just_stars');
    if(!reviews) return false; // wait for review widget
    var anc=[], n=title; while(n){ anc.push(n); n=n.parentElement; }
    var stack=priceEl; while(stack && anc.indexOf(stack)===-1) stack=stack.parentElement;
    if(!stack) return true;
    function child(e){ var x=e; while(x&&x.parentElement&&x.parentElement!==stack) x=x.parentElement; return (x&&x.parentElement===stack)?x:null; }
    var titleC=child(title), jrxC=child(jrx), priceC=child(priceEl);
    if(!(titleC&&jrxC&&priceC)) return true;
    var anchor=titleC;
    if(sub){ stack.insertBefore(sub, titleC.nextSibling); anchor=sub; }
    stack.insertBefore(reviews, anchor.nextSibling);
    stack.insertBefore(priceC, reviews.nextSibling);
    stack.insertBefore(jrxC, priceC.nextSibling);
    jrx.insertBefore(partno, badges);
    return true;
  }
  if(!reorderInfo()){ var rt=0, riv=setInterval(function(){ rt++; if(reorderInfo()||rt>50) clearInterval(riv); },100); }
})();
